__turbopack_context__.v({
  "container": "MapView-module-scss-module__LQWeRq__container",
  "map": "MapView-module-scss-module__LQWeRq__map",
});
